import React from 'react';
import Flag from '../../shared/atoms/Flag';
import { HiExclamation } from 'react-icons/hi';
import { FaGlasses } from 'react-icons/fa';
import type * as def from './SimFlag.def';
import './SimFlag.css';

const SimFlag = ({ simFlag, changes, readOnly, isLoading, onToggleSim, onMerge, variant="default" }: def.SimFlagProps) => {

    const hasChanges = !readOnly && changes?.hasChanges && !isLoading;

    const tooltipContent = (
         <div className="sim-flag-tooltip-container">
             <div className="sim-flag-tooltip-header">
                 <HiExclamation className={`sim-flag-tooltip-icon ${
                     simFlag
                     ? 'sim-flag-tooltip-icon-active'
                     : 'sim-flag-tooltip-icon-inactive'
                 }`} />
                 <span className="sim-flag-tooltip-title">
                     {simFlag ? 'Simulation Active' : 'Changes Available'}
                 </span>
             </div>
             <div className="sim-flag-tooltip-desc">
                 {simFlag
                 ? 'You are viewing simulation mode. Merge changes to apply them to live mode.'
                 : 'There are changes in simulation mode. Switch to simulation to view changes.'
                 }
             </div>
             <div className="sim-flag-tooltip-actions">
                 {!simFlag ? (
                 <>
                     <button
                     onClick={(e) => {
                         e.stopPropagation();
                         if (onToggleSim) onToggleSim();
                     }}
                     className="sim-flag-btn-green"
                     >
                     View Changes
                     </button>
                    {variant != "only_view_changes" && 

                      <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (onMerge) onMerge();
                        }}
                        className="sim-flag-btn-blue"
                        >
                      Merge to Live
                      </button>
                    }
                 </>
                 ) : (
                 <>
                     <button
                     onClick={(e) => {
                         e.stopPropagation();
                         if (onToggleSim) onToggleSim();
                     }}
                     className="sim-flag-btn-blue"
                     >
                     Back to Live
                     </button>
                     <button
                     onClick={(e) => {
                         e.stopPropagation();
                         if (onMerge) onMerge();
                     }}
                     className="sim-flag-btn-green"
                     >
                     Merge to Live
                     </button>
                 </>
                 )}
             </div>
         </div>
    );

    return (
        <div className="sim-flag-container">
            <div className="sim-flag-left-group">
                {hasChanges && (
                    <Flag 
                        tooltipContent={tooltipContent}
                        triggerClassName={`sim-flag-trigger ${
                            simFlag 
                            ? 'sim-flag-trigger-active' 
                            : 'sim-flag-trigger-inactive'
                        }`}
                    > 
                         <HiExclamation className="w-4 h-4" />
                         <FaGlasses className="w-3 h-3" />
                    </Flag>
                )}
                
              <span className="sim-flag-label">
                {simFlag ? "Simulation" : "Live"}
              </span>
            </div>

            <div className="sim-flag-toggle-wrapper">
              {hasChanges && (
                <div className={`sim-flag-glow ${
                  simFlag
                    ? 'sim-flag-glow-active'
                    : 'sim-flag-glow-inactive'
                }`}></div>
              )}
              
              <div
                className={`sim-flag-toggle-track ${
                  simFlag
                    ? "sim-flag-toggle-track-active"
                    : "sim-flag-toggle-track-inactive"
                } ${
                  hasChanges
                    ? simFlag
                      ? 'sim-flag-track-hover-sim'
                      : 'sim-flag-track-hover-live'
                    : 'sim-flag-track-hover-default'
                }`}
                onClick={onToggleSim}
              >
                <div
                  className={`sim-flag-toggle-knob ${
                    simFlag
                      ? "sim-flag-toggle-knob-active"
                      : "sim-flag-toggle-knob-inactive"
                  } ${
                    hasChanges
                      ? isLoading
                        ? ''
                        : !simFlag
                          ? 'sim-flag-toggle-knob-bounce' 
                          : ''
                      : ''
                  }`}
                >
                    <div className={`sim-flag-knob-dot ${
                      simFlag 
                          ? "sim-flag-knob-dot-active" 
                          : "sim-flag-knob-dot-inactive"
                    }`}></div>
                  
                </div>
              </div>
            </div>
        </div>
    );
};

export default SimFlag;